import { __read, __spread } from "tslib";
var collector = "UNIMPLEMENTED_WARN_COLLECTOR";
export function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    try {
        if (process.env.NODE_ENV === "development") {
            console.warn.apply(console, __spread(args));
        }
        if (typeof collector === "function") {
            collector.apply(void 0, __spread(args));
        }
    }
    catch (err) {
        // env
    }
}
//# sourceMappingURL=warn.js.map